<template>
  <v-container grid-list-md pa-0 ma-2 style="max-width: calc(100% - 16px)">
    <v-layout row wrap>
      <v-flex xs12 sm6 md4>
        <SelectCreditors
          :multiple="false"
          :selected="selectedCreditor"
          :active="true"
          @selectedCreditors="changeSelectCreditor($event)"></SelectCreditors>
      </v-flex>
      <v-flex xs12 sm6 md2>
        <v-menu offset-y>
          <v-text-field
            slot="activator"
            label="Data"
            :value="filtro_data.split('-').reverse().join('/')"
            box
            readonly />
          <v-date-picker v-model="filtro_data" locale="br" />
        </v-menu>
      </v-flex>
      <v-flex xs12 sm6 md2>
        <v-btn
          :disabled="!selectedCreditor"
          large
          :class="accent"
          color="info"
          @click="searchPreparedNotifications"
          :loading="loading"
          >Atualizar</v-btn
        >
      </v-flex>
      <v-flex xs12 sm6 md4 class="botaoAnalisar" v-if="selectedCreditor">
        <v-btn large :class="accent" color="success" @click="openMetabase"
          >Analisar
          <v-icon small class="ml-1" style="margin-bottom: 1px"> mdi-open-in-new </v-icon></v-btn
        >
      </v-flex>
      <v-flex xs12>
        <v-data-table
          locale="pt-br"
          no-data-text="Nenhum prepare encontrado"
          style="border: 1px solid rgba(0, 0, 0, 0.12); border-radius: 4px"
          :headers="headers"
          :items="prepareHistoryAgg"
          hide-actions
          :custom-sort="customSort"
          :pagination.sync="paginationStrategyTable"
          item-key="stimulus_id"
          :expand="expand"
          :items-per-page="-1">
          <template v-slot:footer>
            <tr>
              <td style="font-weight: bold; text-align: right" colspan="6">Gasto total</td>
              <td style="font-weight: bold; text-align: center">
                {{ totalBudget | numeral("$0,0.00") }}
              </td>
            </tr>
          </template>
          <template slot="headerCell" slot-scope="props">
            <v-tooltip top dark>
              <template v-slot:activator="{ on }">
                <span v-if="props.header.text === 'Stimulus'" v-on="on"
                  >{{ props.header.text }} <br />Abordagem</span
                >
                <span v-else v-on="on">{{ props.header.text }}</span>
              </template>
              <span v-if="props.header.text === 'Stimulus'"
                >{{ props.header.text }} <br />Abordagem</span
              >
              <span v-else>{{ props.header.text }}</span>
            </v-tooltip>
          </template>
          <template v-slot:items="props">
            <!-- <tr> -->
            <!-- <tr @click="props.expanded = !props.expanded"> -->
            <tr @click="expansor(props)" style="cursor: pointer">
              <td
                @click="expansor(props.item.prepares)"
                style="text-align: center; background-color: #e1f5fe">
                {{ props.item.creditor_id }} - {{ props.item.priority }}
              </td>
              <td class="text-truncate" style="max-width: 10px; background-color: #e1f5fe">
                {{ props.item.debt_node_name }}
              </td>
              <td class="text-truncate" style="max-width: 10px; background-color: #e1f5fe">
                <div class="text-truncate">
                  <a
                    style="font-size: 16px; font-weight: bold"
                    @click="goToStimulus(props.item.creditor_id)"
                    ><span>{{ props.item.stimulus_id }} - {{ props.item.name }} </span></a
                  >
                  <v-tooltip top v-if="!props.item.active">
                    <template v-slot:activator="{ on }">
                      <span
                        v-on="on"
                        class="red lighten-4 red--text text--darken-2"
                        style="
                          font-size: 11px;
                          line-height: 12px;
                          padding: 2px 4px 0px 4px;
                          border-radius: 4px;
                          font-weight: 500;
                          margin-top: auto;
                          margin-left: 4px;
                        ">
                        DESABILITADO
                      </span>
                    </template>
                  </v-tooltip>
                  <v-tooltip top v-if="props.item.hot">
                    <template v-slot:activator="{ on }">
                      <span
                        v-on="on"
                        class="red lighten-4 red--text text--darken-2"
                        style="
                          font-size: 11px;
                          line-height: 12px;
                          padding: 2px 4px 0px 4px;
                          border-radius: 4px;
                          font-weight: 500;
                          margin-top: auto;
                          margin-left: 4px;
                        ">
                        HOT
                      </span>
                    </template>
                  </v-tooltip>
                </div>
                <div class="text-truncate" style="margin-top: 8px">
                  <a @click="goToApproachFlow(props.item.approach_flow_id)"
                    ><span
                      >{{ props.item.approach_flow_id }} - {{ props.item.approach_flow_name }}</span
                    ></a
                  >
                </div>
              </td>
              <td style="text-align: center; background-color: #e1f5fe">
                <div>
                  {{ props.item.sumAmountPrepared | numeral("0,0") }}
                </div>
                <div>
                  {{
                    (props.item.sumAmountPrepared / props.item.sumAmountPreparedTotal)
                      | numeral("0.00%")
                  }}
                </div>
              </td>

              <td
                style="text-align: center; background-color: #e1f5fe"
                :class="setColor(props.item.sumAmountSkipped)">
                <div>
                  {{ props.item.sumAmountSkippedTotal | numeral("0,0") }}
                </div>
                <div>
                  {{ props.item.sumAmountSkipped | numeral("0.00%") }}
                </div>
              </td>
              <td style="text-align: center; background-color: #e1f5fe">
                <div>
                  {{ props.item.sumAmountWaitTotal | numeral("0,0") }}
                </div>
                <div>
                  {{ props.item.sumAmountWait | numeral("0.00%") }}
                </div>
              </td>
              <td style="text-align: center; background-color: #e1f5fe">
                {{ props.item.sumAmountAvgCost | numeral("$0,0.00") }}
              </td>
              <td style="text-align: center; background-color: #e1f5fe">
                {{ props.item.prepared_at | formatTime }}
              </td>
              <td style="text-align: center; background-color: #e1f5fe">
                <v-menu bottom left>
                  <template v-slot:activator="{ on }" style="background-color: #e1f5fe">
                    <v-btn
                      icon
                      v-on="on"
                      @click.native.stop
                      class="ml-1"
                      style="background-color: #e1f5fe">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-tile
                      v-if="props.item.active && props.item.datePreparedAt == props.item.today"
                      @click="openDialogConfirm(props.item.stimulus_id, props.item.prepared_at)">
                      <v-list-tile-title> Cancelar Envio </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="openMetabase(props.item, true)">
                      <v-list-tile-title>
                        Analisar
                        <v-icon small class="ml-1" style="margin-bottom: 1px">
                          mdi-open-in-new
                        </v-icon>
                      </v-list-tile-title>
                    </v-list-tile>
                      <v-list-tile @click="openMetabaseVolume(props.item, true)">
                      <v-list-tile-title>
                        Analisar volume diário
                        <v-icon small class="ml-1" style="margin-bottom: 1px">
                          mdi-open-in-new
                        </v-icon>
                      </v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
          <template v-slot:expand="">
            <v-card flat>
              <v-data-table
                :headers="headers_expanded"
                :items="prepares"
                :custom-sort="customSortExpand"
                :pagination.sync="prepareOptions"
                item-key="name"
                hide-actions
                elevation-5
                no-data-text="Nenhum disparo encontrado">
                <template slot="headerCell" slot-scope="prepare">
                  <v-tooltip top dark>
                    <template v-slot:activator="{ on }">
                      <span v-if="prepare.header.text === 'Preparados'" v-on="on"
                        >{{ prepare.header.text }} <br />Gasto Previsto (R$)</span
                      >
                      <span v-else v-on="on">{{ prepare.header.text }}</span>
                    </template>
                    <span v-if="prepare.header.text === 'Preparados'"
                      >{{ prepare.header.text }} <br />Gasto Previsto (R$)</span
                    >
                    <span v-else>{{ prepare.header.text }}</span>
                  </v-tooltip>
                </template>
                <template v-slot:items="prepare">
                  <tr>
                    <td style="text-align: center; background-color: #e0f2f1">
                      <span :class="`tag-approach-type small ${prepare.item.approach_type}`">{{
                        translateSkipType(prepare.item.approach_type)
                      }}</span>
                    </td>
                    <td style="text-align: center; background-color: #e0f2f1">
                      {{ prepare.item.offset }} - {{ prepare.item.time.substring(0, 2) }}h
                    </td>
                    <td style="text-align: left; background-color: #e0f2f1">
                      <div style="margin-top: 4px">
                        <span>{{ selectContentFirst(prepare) }}</span> <br />
                        <div
                          v-if="
                            selectContentSecond(prepare) &&
                            selectContentSecond(prepare).substring(0, 3) == 'htt'
                          ">
                          <a :href="selectContentSecond(prepare)">{{
                            selectContentSecond(prepare)
                          }}</a>
                        </div>
                        <div v-else>
                          <span>{{ selectContentSecond(prepare) }}</span>
                        </div>
                      </div>
                    </td>
                    <td style="text-align: center; background-color: #e0f2f1">
                      <div style="text-align: center">
                        <span>{{ prepare.item.value | numeral("0,0") }}</span>
                      </div>
                      <div style="text-align: center">
                        <span>{{
                          (prepare.item.avg_cost * prepare.item.value) | numeral("$ 0,0.00")
                        }}</span>
                      </div>
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <v-data-table
                :headers="headers_expanded_skip"
                :items="prepares_skip"
                :custom-sort="customSortExpand"
                :pagination.sync="prepareOptions"
                item-key="name"
                hide-actions
                elevation-5
                no-data-text="Nenhum esquipe encontrado">
                <template v-slot:items="prepare">
                  <tr>
                    <td style="text-align: center; background-color: #ede7f6">
                      {{ translateSkipType(prepare.item.approach_type) }}
                    </td>
                    <td style="text-align: center; background-color: #ede7f6">
                      {{ prepare.item.offset }} - {{ prepare.item.time.substring(0, 2) }}h
                    </td>
                    <td style="text-align: left; background-color: #ede7f6">
                      <div style="margin-top: 4px">
                        <span>{{ selectContentFirst(prepare) }}</span> <br />
                        <div
                          v-if="
                            selectContentSecond(prepare) &&
                            selectContentSecond(prepare).substring(0, 3) == 'htt'
                          ">
                          <a :href="selectContentSecond(prepare)">{{
                            selectContentSecond(prepare)
                          }}</a>
                        </div>
                        <div v-else>
                          <span>{{ selectContentSecond(prepare) }}</span>
                        </div>
                      </div>
                    </td>
                    <td style="text-align: center; background-color: #ede7f6">
                      {{ prepare.item.value | numeral("0,0") }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
          </template>
          <template v-slot:no-data>
            <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5)">
              <v-layout justify-center align-center>
                <v-progress-circular
                  v-if="loading"
                  indeterminate
                  color="primary"></v-progress-circular>
                <strong v-if="!loading" class="py-2" style="font-color: red; font-size: 14px"
                  >Nenhum prepare encontrado</strong
                >
              </v-layout>
            </v-container>
          </template>
        </v-data-table></v-flex
      ></v-layout
    >
    <DialogDisablePrepareHistory
      :dialog.sync="dialogDisablePrepareHistory"
      :stimulusId="stimulusId"
      :preparedAt="preparedAt"
      @confirmed="confirmDisablePrepareHistory" />
  </v-container>
</template>

<script>
import store from "@/store";
import moment from "moment";
import checkMobile from "@/mixins/checkMobile";
import SelectCreditors from "@/components/creditor/SelectCreditors";
import prepareHistory from "@/services/consolidation-tree/prepare-history";
import skips from "@/utils/skips-types";
import DialogDisablePrepareHistory from "./components/dialogs/dialogDisablePrepareHistory";

export default {
  name: "prepare-history",
  data() {
    return {
      dialogDisablePrepareHistory: false,
      filtro_data: new Date().toISOString().slice(0, 10),
      prepareOptions: {
        descending: false,
        rowsPerPage: -1,
      },
      interval: null,
      disabled: null,
      trava: true,
      accent: false,
      loading: false,
      autoUpdate: true,
      doneFetching: false,
      prepares: [],
      histories: [],
      selectedCreditor: [],
      selectedSkipTypes: [],
      totalBudget: 0,
      skips: [],
      skipsTypes: [
        "SKIP_END_OF_APPROACH_CALL_CELLPHONE",
        "SKIP_END_OF_APPROACH_CALL_PHONE",
        "SKIP_END_OF_APPROACH_EMAIL",
        "SKIP_END_OF_APPROACH_SMS",
        "SKIP_END_OF_APPROACH_PUSH",
        "SKIP_INCONSISTENT_VAR",
        "SKIP_INCONSISTENT_VAR_ASSET",
        "SKIP_CREDITOR_BUDGET_REACHED",
        "SKIP_STIMULUS_BUDGET_REACHED",
        "SKIP_OUT_OF_APPROACH_CALL_CELLPHONE",
        "SKIP_OUT_OF_APPROACH_CALL_PHONE",
        "SKIP_OUT_OF_APPROACH_EMAIL",
        "SKIP_OUT_OF_APPROACH_SMS",
        "SKIP_OUT_OF_APPROACH_PUSH",
        "SKIP_BLACKLIST",
        "SKIP_NOTIFICADO_LOCALIZADO",
        "SKIP_CUSTOMER_LOGADO",
      ],
      selectedStatusTypes: [],
      statusType: ["Enviado", "Atrasado"],
      expand: false,
      headers: [
        {
          text: "Credor - Prioridade Credor",
          align: "left",
          value: "creditor_id-priority",
          width: "5%",
          class: "body-2 black--text font-weight-medium light-blue lighten-4",
          sortable: false,
        },
        {
          text: "Nó",
          align: "left",
          value: "debt_node_name",
          width: "10%",
          sortable: false,
          class: "body-2 black--text font-weight-medium light-blue lighten-4",
        },
        {
          text: "Stimulus",
          align: "left",
          value: "stimulus-abordagem",
          width: "45%",
          sortable: false,
          class: "body-2 black--text font-weight-medium light-blue lighten-4",
        },
        {
          text: "Preparados",
          align: "center",
          value: "sumAmountPrepared",
          width: "10%",
          sortable: false,
          class: "body-2 black--text font-weight-medium light-blue lighten-4",
        },
        {
          text: "Esquipados",
          align: "center",
          value: "sumAmountSkipped",
          width: "10%",
          sortable: false,
          class: "body-2 black--text font-weight-medium light-blue lighten-4",
        },
        {
          text: "Aguardando",
          align: "center",
          value: "sumAmountWait",
          width: "10%",
          sortable: false,
          class: "body-2 black--text font-weight-medium light-blue lighten-4",
        },
        {
          text: "Gasto Previsto (R$)",
          align: "center",
          value: "sumAmountAvgCost",
          width: "5%",
          sortable: false,
          class: "body-2 black--text font-weight-medium light-blue lighten-4",
        },
        {
          text: "Preparado (h)",
          align: "center",
          value: "prepared_at",
          width: "5%",
          sortable: false,
          class: "body-2 black--text font-weight-medium light-blue lighten-4",
        },
        {
          text: "",
          align: "center",
          value: "",
          width: "5%",
          sortable: false,
          class: "body-2 black--text font-weight-medium light-blue lighten-4",
        },
      ],
      headers_expanded: [
        {
          text: "Tipo",
          align: "center",
          value: "type",
          width: "10%",
          sortable: false,
          class: "teal lighten-4",
        },
        {
          text: "Offset - Hora",
          align: "center",
          value: "offset-time",
          width: "10%",
          sortable: false,
          class: "teal lighten-4",
        },
        {
          text: "Conteúdo",
          align: "left",
          value: "subject",
          width: "72%",
          sortable: false,
          class: "teal lighten-4",
        },
        {
          text: "Preparados",
          align: "center",
          value: "value-avg_cost",
          width: "8%",
          sortable: false,
          class: "teal lighten-4",
        },
      ],
      headers_expanded_skip: [
        {
          text: "Tipo",
          align: "center",
          value: "type",
          width: "10%",
          sortable: false,
          class: "deep-purple lighten-4",
        },
        {
          text: "Offset - Hora",
          align: "center",
          value: "offset-time",
          width: "10%",
          sortable: false,
          class: "deep-purple lighten-4",
        },
        {
          text: "Conteúdo",
          align: "left",
          value: "url",
          width: "72%",
          sortable: false,
          class: "deep-purple lighten-4",
        },
        {
          text: "Esquipados",
          align: "center",
          value: "value",
          width: "8%",
          sortable: false,
          class: "deep-purple lighten-4",
        },
      ],
      query: {},
      creditor: {},
      paginationStrategyTable: {
        rowsPerPage: -1,
      },
      prepareHistory: [],
      prepareHistoryAgg: [],
      selectedApproachesTypes: [],
      approachesTypes: ["SMS", "EMAIL", "PUSH", "CALL_CELLPHONE", "CALL_PHONE", "WHATSAPP"],
      stimulusId: 0,
      preparedAt: 0,
    };
  },
  components: {
    SelectCreditors,
    DialogDisablePrepareHistory,
  },
  mixins: [checkMobile],
  async created() {
    this.skips = skips.skips;

    this.query = this.$route.query;

    if (this.query && Object.keys(this.query).length == 0) {
      this.query = store.getters.getPreparesDailyFilters;
    }

    if (this.query && Object.keys(this.query).length != 0) {
      if (this.query.descending) {
        if (typeof this.query.descending == "string") {
          this.descending = JSON.parse(this.query.descending.toLowerCase());
        } else {
          this.descending = this.query.descending;
        }
      }
      if (this.query.creditors) {
        let ids = this.query.creditors.split(",");
        ids.forEach((id) => {
          this.selectedCreditor.push(id);
        });
      }
      if (this.query.filtro_data) {
        this.filtro_data = this.query.filtro_data;
      }
    }

    this.doneFetching = true;
  },
  methods: {
    customSort(items, column) {
      if (column == "creditor_id") {
        items.sort((a, b) => {
          if (a["creditor_id"] == b["creditor_id"]) {
            return Number(a["priority"]) < Number(b["priority"]) ? -1 : 1;
          } else {
            return 0;
          }
        });
      }
      return items;
    },
    customSortExpand(items) {
      const importOrder = [
        "SMS",
        "PUSH",
        "EMAIL",
        "SKIP_INCONSISTENT_VAR",
        "SKIP_INCONSISTENT_VAR_ASSET",
        "SKIP_BUDGET_REACHED",
        "SKIP_BLACKLIST",
        "SKIP_END_OF_APPROACH_CALL_CELLPHONE",
        "SKIP_END_OF_APPROACH_CALL_PHONE",
        "SKIP_END_OF_APPROACH_EMAIL",
        "SKIP_END_OF_APPROACH_SMS",
        "SKIP_END_OF_APPROACH_PUSH",
        "SKIP_OUT_OF_APPROACH_CALL_CELLPHONE",
        "SKIP_OUT_OF_APPROACH_CALL_PHONE",
        "SKIP_OUT_OF_APPROACH_EMAIL",
        "SKIP_OUT_OF_APPROACH_SMS",
        "SKIP_OUT_OF_APPROACH_PUSH",
        "SKIP_NOTIFICADO_LOCALIZADO",
        "SKIP_CUSTOMER_LOGADO",
        "SKIP_MULTICREDITOR",
        "SKIP_ROTATE_MULTICREDITOR_1",
        "SKIP_ROTATE_MULTICREDITOR_2",
        "SKIP_ROTATE_MULTICREDITOR_3",
        "SKIP_ROTATE_MULTICREDITOR_4",
        "SKIP_ROTATE_MULTICREDITOR_5_PLUS",
        "SKIP_PREPARE_DUPLICATED",
        "SKIP_STIMULUS_BUDGET_REACHED",
        "WAIT",
      ];

      const sortByObject = importOrder.reduce((obj, item, index) => {
        obj[item] = index;
        return obj;
      }, {});

      const sortedItems = items.sort((a, b) => {
        const approachOrderA =
          sortByObject[a.approach_type] !== undefined
            ? sortByObject[a.approach_type]
            : Number.MAX_SAFE_INTEGER;
        const approachOrderB =
          sortByObject[b.approach_type] !== undefined
            ? sortByObject[b.approach_type]
            : Number.MAX_SAFE_INTEGER;

        if (approachOrderA !== approachOrderB) {
          return approachOrderA - approachOrderB;
        }

        // ordena por offset
        if (a.offset !== b.offset) {
          return a.offset - b.offset;
        }

        //ordena o valor por hora
        if (a.time !== b.time) {
          let a_hour = a.time.slice(0, 2);
          let b_hour = b.time.slice(0, 2);
          return a_hour - b_hour;
        }

        // ordena por value (número ou string)
        if (typeof a.value === "string" && typeof b.value === "string") {
          return b.value.localeCompare(a.value);
        }
        return (b.value !== undefined ? b.value : 0) - (a.value !== undefined ? a.value : 0);
      });

      return sortedItems;
    },
    async searchPreparedNotifications() {
      this.addfilters();
      this.loading = true;
      let params = {};
      let creditorIds = this.selectedCreditor;
      if (creditorIds) params.creditorIds = this.query.creditors;

      params.start_date = this.filtro_data;

      let approachesTypes = this.selectedApproachesTypes;
      if (approachesTypes.length) params.approachesTypes = this.query.approachesTypes;

      let skipsTypes = this.selectedSkipTypes;
      if (skipsTypes.length) params.skipTypes = this.query.skipTypes;

      await prepareHistory
        .list(params)
        .then(async (res) => {
          this.totalBudget = 0;
          this.searchLastPrepared(res.objects);
          await this.stimulusPrepare();
        })
        .catch((error) => {
          console.error(error);
          this.$store.commit("showSnackbar", "Houve um erro ao buscar os dados");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setPreparesToAgg(stimulusArray, setToPrepare) {
      this.prepareHistory.forEach((prepare) => {
        prepare.prepares = [];
        prepare.prepares_skip = [];
        let { stimulus_id } = prepare;
        if (!setToPrepare.has(stimulus_id)) {
          stimulusArray.push({
            creditor_id: prepare.creditor_id,
            stimulus_id: stimulus_id,
            priority: prepare.stimulus.order,
            name: prepare.stimulus.name,
            approach_flow_id: prepare.stimulus.approach_flow.id,
            debt_node_name: prepare.stimulus.debt_node.name,
            approach_flow_name: prepare.stimulus.approach_flow.name,
            last_update_user: this.getName(prepare),
            last_update_at: prepare.stimulus.updated_at,
            prepared_at: prepare.updated_at,
            hot: prepare.stimulus.hot,
            prepares: [],
            prepares_skip: [],
            amountAvgCost: [],
            sumAmountAvgCost: 0,
            amountPrepared: [],
            sumAmountPrepared: 0,
            amountPreparedSkip: [],
            sumAmountPreparedSkip: 0,
            sumAmountPreparedTotal: 0,
            amountSkipped: [],
            sumAmountSkipped: 0,
            sumAmountSkippedTotal: 0,
            amountWait: [],
            sumAmountWait: 0,
            sumAmountWaitTotal: 0,
            active: prepare.active,
            datePreparedAt: moment(prepare.updated_at).format("DD/MM/YYYY"),
            today: moment().format("DD/MM/YYYY"),
          });
          setToPrepare.add(stimulus_id);
        }
      });
    },

    doSums(arrayToSum) {
      let totalValue = 0;

      return arrayToSum.reduce(
        (previousValue, currentValue) => previousValue + currentValue,
        totalValue
      );
    },
    sumAmountAvgCost(arrayToSum) {
      let totalValue = 0;
      arrayToSum.filter((item) => {
        if (item.avg_cost) {
          totalValue += item.avg_cost * item.value;
        }
      });
      this.totalBudget += totalValue;
      return totalValue;
    },
    sumAmountPrepared(arrayToSum) {
      let totalValue = 0;

      arrayToSum.filter((item) => {
        if (item.value >= 0) {
          totalValue += parseInt(item.value);
        }
      });
      return totalValue;
    },
    sumAmountSkipped(arrayToSum) {
      let totalValue = 0;
      let approachType = [
        "SKIP_END_OF_APPROACH_CALL_CELLPHONE",
        "SKIP_END_OF_APPROACH_CALL_PHONE",
        "SKIP_END_OF_APPROACH_EMAIL",
        "SKIP_END_OF_APPROACH_SMS",
        "SKIP_END_OF_APPROACH_PUSH",
        "SKIP_OUT_OF_APPROACH_CALL_CELLPHONE",
        "SKIP_OUT_OF_APPROACH_CALL_PHONE",
        "SKIP_OUT_OF_APPROACH_EMAIL",
        "SKIP_OUT_OF_APPROACH_SMS",
        "SKIP_OUT_OF_APPROACH_PUSH",
        "SKIP_RECENTLY_NOTIFIED",
        "SKIP_PROPOSAL_CONFIRMED",
        "SKIP_PREPARE_DUPLICATED",
        "SKIP_RECENTLY_WHATSAPP_NOTIFIED",
        "SKIP_INCONSISTENT_VAR",
        "SKIP_INCONSISTENT_VAR_ASSET",
        "SKIP_MULTICREDITOR",
        "SKIP_BLACKLIST",
        "SKIP_BUDGET_REACHED",
        "SKIP_CREDITOR_BUDGET_REACHED",
        "SKIP_STIMULUS_BUDGET_REACHED",
        "SKIP_END_OF_APPROACH_WHATSAPP",
        "SKIP_NOTIFICADO_LOCALIZADO",
        "SKIP_CUSTOMER_LOGADO",
        "SKIP_ROTATE_MULTICREDITOR_1",
        "SKIP_ROTATE_MULTICREDITOR_2",
        "SKIP_ROTATE_MULTICREDITOR_3",
        "SKIP_ROTATE_MULTICREDITOR_4",
        "SKIP_ROTATE_MULTICREDITOR_5_PLUS",
      ];

      arrayToSum.filter((item) => {
        if (item.value > 0 && approachType.includes(item.approach_type)) {
          totalValue += parseInt(item.value);
        }
      });
      return totalValue;
    },
    sumAmountWait(arrayToSum) {
      let totalValue = 0;

      arrayToSum.filter((item) => {
        if (item.value > 0 && item.approach_type == "WAIT") {
          totalValue += parseInt(item.value);
        }
      });
      return totalValue;
    },
    sumAmounts(arrayToSumAmounts) {
      arrayToSumAmounts.forEach((item) => {
        item.sumAmountAvgCost += this.sumAmountAvgCost(item.prepares);
        item.sumAmountPrepared += this.sumAmountPrepared(item.prepares);
        item.sumAmountPreparedSkip += this.sumAmountPrepared(item.prepares_skip);
        item.sumAmountPreparedTotal = item.sumAmountPrepared + item.sumAmountPreparedSkip;
        item.sumAmountSkippedTotal += this.sumAmountSkipped(item.prepares_skip);
        item.sumAmountSkipped = item.sumAmountSkippedTotal / item.sumAmountPreparedTotal;
        item.sumAmountWaitTotal += this.sumAmountWait(item.prepares_skip);
        item.sumAmountWait = item.sumAmountWaitTotal / item.sumAmountPreparedTotal;
      });

      return arrayToSumAmounts;
    },
    translateSkipType(approach_type) {
      let _type = this.skips.find((obj) => {
        return obj.value == approach_type;
      });
      return _type ? _type.name : approach_type;
    },
    selectContentFirst(prepare) {
      if (prepare.item.content.subject) {
        return prepare.item.content.subject;
      } else if (prepare.item.content.title) {
        return prepare.item.content.title;
      } else if (prepare.item.content.text) {
        return prepare.item.content.text;
      } else if (prepare.item.content.message) {
        return prepare.item.content.message;
      }
    },
    selectContentSecond(prepare) {
      if (prepare.item.content.url) {
        return prepare.item.content.url;
      } else if (prepare.item.content.body) {
        return prepare.item.content.body;
      }
    },
    setColor(value) {
      if (value * 100 < 10) return "";
      else if (value * 100 > 50) return "text-red";
      else return "text-orange";
    },
    goToStimulus(creditor_id) {
      this.$router.push({
        name: "Estímulos",
        query: {
          creditor: creditor_id,
        },
      });
    },
    goToApproachFlow(approach_id) {
      this.$router.push({
        name: "Fluxo de abordagem",
        params: {
          approach_id: approach_id,
        },
      });
    },
    searchLastPrepared(prepared) {
      this.prepareHistory = [];
      let _preparedObj = {};
      prepared.forEach((prepare) => {
        //Ajuste para pegar todos os skips
        if (prepare.content.body) {
          //PUSH
          _preparedObj[
            prepare.approach_type +
              "-" +
              prepare.stimulus_id +
              "-" +
              prepare.offset +
              "-" +
              prepare.time +
              "-" +
              prepare.content.body
          ] = prepare;
        } else if (prepare.content.template) {
          //EMAIL
          _preparedObj[
            prepare.approach_type +
              "-" +
              prepare.stimulus_id +
              "-" +
              prepare.offset +
              "-" +
              prepare.time +
              "-" +
              prepare.content.template
          ] = prepare;
        } else if (prepare.content.text) {
          //SMS
          _preparedObj[
            prepare.approach_type +
              "-" +
              prepare.stimulus_id +
              "-" +
              prepare.offset +
              "-" +
              prepare.time +
              "-" +
              prepare.content.text
          ] = prepare;
        } else if (prepare.content.message) {
          //WHATS
          _preparedObj[
            prepare.approach_type +
              "-" +
              prepare.stimulus_id +
              "-" +
              prepare.offset +
              "-" +
              prepare.time +
              "-" +
              prepare.content.message
          ] = prepare;
        } else {
          _preparedObj[
            prepare.approach_type +
              "-" +
              prepare.stimulus_id +
              "-" +
              prepare.offset +
              "-" +
              prepare.time
          ] = prepare;
        }
      });
      Object.keys(_preparedObj).forEach((key) => {
        this.prepareHistory.push(_preparedObj[key]);
      });
    },
    async stimulusPrepare() {
      let allStimulus = [];
      let prepareSet = new Set();
      let arrayApproach = ["SMS", "EMAIL", "PUSH", "CALL_PHONE", "CALL_CELLPHONE", "WHATSAPP"];

      this.setPreparesToAgg(allStimulus, prepareSet);
      this.prepareHistoryAgg = allStimulus;
      this.prepareHistory.forEach((prepare) => {
        this.prepareHistoryAgg.forEach((stimulus) => {
          if (prepare.stimulus_id == stimulus.stimulus_id) {
            if (arrayApproach.includes(prepare.approach_type)) {
              stimulus.prepares.push(prepare);
            } else {
              stimulus.prepares_skip.push(prepare);
            }
          }
        });
      });
      this.prepareHistoryAgg.forEach((stimulus) => {
        stimulus.prepares.sort((a, b) => {
          if (a.approach_type == b.approach_type && a.offset < b.offset) return -1;
          if (a.approach_type == b.approach_type && a.offset > b.offset) return 1;
          if (a.approach_type == b.approach_type && a.offset == b.offset && a.time < b.time)
            return -1;
          if (a.approach_type == b.approach_type && a.offset == b.offset && a.time > b.time)
            return 1;
        });
        stimulus.prepares_skip.sort((a, b) => {
          if (a.approach_type == b.approach_type && a.offset < b.offset) return -1;
          if (a.approach_type == b.approach_type && a.offset > b.offset) return 1;
          if (a.approach_type == b.approach_type && a.offset == b.offset && a.time < b.time)
            return -1;
          if (a.approach_type == b.approach_type && a.offset == b.offset && a.time > b.time)
            return 1;
        });
      });
      this.sumAmounts(this.prepareHistoryAgg);
      await this.customSort(this.prepareHistoryAgg, "creditor_id");

      return;
    },
    changeSelectCreditor(event) {
      this.selectedCreditor = event;
      // this.searchPreparedNotifications();
    },
    addfilters() {
      this.query = {};
      if (this.selectedCreditor) {
        this.query.creditors = this.selectedCreditor;
      }
      if (this.filtro_data) {
        this.query.filtro_data = this.filtro_data;
      }

      // if (this.selectedApproachesTypes.length) {
      //   this.query.approachesTypes = this.selectedApproachesTypes
      //     .map((sp) => sp)
      //     .join(",");
      // }

      // if (this.selectedSkipTypes.length) {
      //   this.query.skipTypes = this.selectedSkipTypes.map((sp) => sp).join(",");
      // }
      this.$store.commit("setPreparesDailyFilters", this.query);
      if (this.$route.path == "/debt-tree/prepares-daily") {
        this.$router.replace({
          name: "Previsão dos preparos do dia",
          query: this.query,
        });
      }
    },
    getName(item) {
      let strategy_snapshot = {};
      try {
        strategy_snapshot = JSON.parse(item.stimulus);
      } catch (e) {
        strategy_snapshot = item.stimulus;
      }
      return strategy_snapshot.last_modification_user
        ? strategy_snapshot.last_modification_user.split(" ")[0] + ","
        : "";
    },
    async expansor(props) {
      props.expanded = !props.expanded;
      let prepares = props.item.prepares;
      this.prepares = prepares;
      let prepares_skip = props.item.prepares_skip;
      this.prepares_skip = prepares_skip;

      return;
    },
    openDialogConfirm(stimulusId, preparedAt) {
      this.stimulusId = stimulusId;
      this.preparedAt = preparedAt;
      this.dialogDisablePrepareHistory = true;
    },
    async confirmDisablePrepareHistory() {
      await prepareHistory.disable(this.stimulusId);
      await this.searchPreparedNotifications();
    },
    openMetabase(prepare = {}, isStimulus = false) {
      const DATE = this.filtro_data;
      var link =
        "https://metabase.quiteja.com.br/dashboard/592-detalhamento-dos-preparos?data=" + DATE;

      if (isStimulus) {
        const STIMULUS_ID = prepare.stimulus_id;
        link = link + "&stimulus_id=" + STIMULUS_ID;
      } else {
        const CREDITOR_ID = this.selectedCreditor;
        link = link + "&creditor_id=" + CREDITOR_ID;
      }

      window.open(link, "_blank");
    },
    openMetabaseVolume(prepare = {}, isStimulus = false) {
      const CREDITOR_ID = this.selectedCreditor;
      var link =
        "https://metabase.quiteja.com.br/question/15860-volume-diario-por-data?creditor_id=" +
        CREDITOR_ID +
        "&estimulo_id=" +
        (isStimulus ? prepare.stimulus_id : "");

      window.open(link, "_blank");
    },
  },
};
</script>
<style scoped>
tr {
  cursor: default;
}

.text-orange {
  color: orange;
  font-weight: bold;
}
.text-red {
  color: red;
  font-weight: bold;
}

.tr-shadow {
  background-color: rgba(0, 0, 0, 0.06);
}

.hot {
  background-color: #f47d76 !important;
  border-color: #f47d76 !important;
}

.received {
  background-color: #d3ffce !important;
  border-color: #d3ffce !important;
}

.span-range {
  display: inline-block;
  width: 45%;
  font-size: small;
}

.good-accurancy {
  font-size: 12px;
  color: #049804;
  font-weight: 400;
}

.v-date-picker-table {
  height: auto !important;
}

.v-date-range .v-menu--inline {
  display: inline;
}

.hot .v-chip__content {
  padding: 4px 5px !important;
  background-color: #f47d76 !important;
  border-color: #f47d76 !important;
}

.received .v-chip__content {
  background-color: #d3ffce !important;
  border-color: #d3ffce !important;
  padding: 0px 9px !important;
}

.botaoAnalisar {
  text-align: end;
}

::v-deep table.v-table tbody td:first-child,
table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  padding-right: 0px !important;
  padding-left: 0px !important;
}
</style>
